<template>
    <div class="history">
        <div class="formCollapse">
            <van-collapse v-model="activeNames" @change="collapseChange">
                <van-collapse-item
                        :title="'条件选择('+siteName+')'"
                        name="1"
                >
                    <div class="choose">
                        <van-field
                                readonly
                                clickable
                                border
                                label="开始时间："
                                :value="startValue"
                                placeholder="选择开始时间"
                                @click="showStartPicker = true"
                        />
                    </div>
                    <div class="choose">
                        <van-field
                            readonly
                            clickable
                            border
                            label="结束时间："
                            :value="endValue"
                            placeholder="选择结束时间"
                            @click="showEndPicker = true"
                        />
                    </div>
                    <!-- <div class="choose">
                        <van-field
                            :columns="paramsColumns"
                            readonly
                            clickable
                            border
                            label="参　　数："
                            :value="paramsVal"
                            placeholder="选择参数"
                            @click="showparamsPicker = true" />
                    </div> -->
                    <!-- <div class="choose">
                        <van-field v-model="ChromatogramMin" type="number" label="色谱下限：" border :disabled="!showPBL"/>
                    </div> -->
                    <div class="choose">
                        <van-field
                            :columns="ChromatogramMax"
                            readonly
                            clickable
                            border
                            :disabled="!showPBL"
                            label="色谱范围："
                            :value="ChromatogramMax"
                            placeholder="选择范围"
                            @click="showMaxPicker = true" />
                    </div>
                    <!-- <div class="choose">
                        <van-field
                            :columns="DistanceMin"
                            readonly
                            clickable
                            border
                            label="距离下限："
                            :value="DistanceMin"
                            placeholder="选择下限"
                            @click="showDisMinPicker = true" />
                    </div> -->
                    <div class="choose">
                        <!-- 允许输入数字，调起带符号的纯数字键盘 -->
                        <van-field
                            :columns="DistanceMax"
                            readonly
                            clickable
                            border
                            label="距离上限："
                            :value="DistanceMax"
                            placeholder="选择上限"
                            @click="showDisMaxPicker = true" />
                    </div>
                    <div class="choose" v-if="showPBL">
                        <van-field name="switch" style="border:none;" label="PBL 叠加：">
                            <template #input>
                                <van-switch v-model="PBLSuperposition" size="20"  />
                            </template>
                        </van-field>
                    </div>
                    <div class="choose">
                        <van-button type="info" size="small" @click="searchData">查询</van-button>
                    </div>
                </van-collapse-item>
            </van-collapse>
        </div>
        <div class="historyChart">
            <div class="chartData" :key="index" v-for="(item,index) in paramsChartTitle">
                <div class="titleBar">
                    {{item.name}}
                    <div class="closeBtn" @click="deleteImg(item,index)"></div>
                </div>
                <div class="hourCharts" >
                    <img class="lidarImg" :src="item.url" alt="">
                </div>
            </div>
        </div>
        <!-- :style="{ height: '45%' }" -->
        <van-popup v-model="showparamsPicker" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="paramsColumns"
                    @cancel="showparamsPicker = false"
                    @confirm="onPramsChange"
            />
        </van-popup>
        <van-popup v-model="showMaxPicker" position="bottom" v-if="showPBL"> 
            <van-picker
                    show-toolbar
                    :columns="ChromatogramMaxColums"
                    @cancel="showMaxPicker = false"
                    @confirm="onChromatogramMaxChange"
            />
        </van-popup>
        <van-popup v-model="showDisMinPicker" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="DistanceMaxColums"
                    @cancel="showDisMinPicker = false"
                    @confirm="onDistanceMinColumsChange"
            />
        </van-popup>
        <van-popup v-model="showDisMaxPicker" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="DistanceMaxColums"
                    @cancel="showDisMaxPicker = false"
                    @confirm="onDistanceMaxColumsChange"
            />
        </van-popup>
        <van-popup v-model="showStartPicker" position="bottom">
            <van-datetime-picker
                    show-toolbar
                    v-model="startCurrentDate"
                    type="datetime"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @cancel="showStartPicker = false"
                    @confirm="onStartChange"
            />
        </van-popup>
        <van-popup v-model="showEndPicker" position="bottom">
            <van-datetime-picker
                    show-toolbar
                    v-model="endCurrentDate"
                    type="datetime"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @cancel="showEndPicker = false"
                    @confirm="onEndChange"
            />
        </van-popup>
    </div>
</template>

<script>
    import echarts from 'echarts'
    import $ from 'jquery'
    import {formatDate} from '../assets/date.js';
    import optionDataInfo from '../api/qirongjiao.json';
    import axios from 'axios';
    export default {
        name: '',
        data () {
            return {
                activeNames:["1"],
                showSitePicker:false,
                siteValue: '',
                siteColumns: [],
                paramsColumns:[],
                paramsValue:[],
                ChromatogramMaxColums:[],
                DistanceMaxColums:[500,1000,1500,3000,6000],
                paramsVal:'消光系数',
                showparamsPicker:false,
                showTypePicker:false,
                typeValue:'',
                typeColumns:['小时值','日均值'],
                showStartPicker:false,
                showEndPicker:false,
                minHour: 10,
                maxHour: 20,
                maxDate: new Date(),
                minDate: new Date(),
                startCurrentDate: new Date(),
                endCurrentDate: new Date(),
                startValue:'',
                endValue:'',
                myChart:null,
                siteInsArr:[],
                allParamsArr:[],
                siteParamsArr:optionDataInfo[0].data,
                formData:{
                    InsNo:'',
                    InsType:'',
                    Parameter:[],
                    TimeStart:'',
                    TimeEnd:'',
                    DataType:-1
                },
                paramsChartTitle:[],
                myChartArr:{},
                DistanceMax:6000,
                DistanceMin:0,
                ChromatogramMax:1,
                ChromatogramMin:0,
                PBLSuperposition:false,
                parkcode:null,
                sitecode:null,
                insCode:null,
                PIndex:null,
                showPBL:true,
                realTimeParamesName:null,
                showDisMaxPicker:false,
                showMaxPicker:false,
                showDisMinPicker:false,
                isShowParames:true,
                siteName:"",
            }
        },
        methods: {
            //初始化参数
            initSiteData(){
                let _this=this;
                let local=localStorage.getItem('user');
                let siteData=sessionStorage.getItem("realTimeIns");
                if(siteData === "" || siteData === null || typeof siteData === "undefined"){
                    _this.$toast.fail({
                        duration:2000,
                        mask:true,
                        message:'请先在站点页选择一个站点！'
                    });
                    _this.$router.push('/RealTime');
                    return false
                }
                siteData=JSON.parse(siteData);
                console.log(siteData);
                let localData=JSON.parse(local);
                let userInfo=JSON.parse(localData.userData);
                _this.parkcode=siteData.Instruments[0].cipark_code;
                _this.sitecode=siteData.Instruments[0].site_code;
                _this.insCode=siteData.Instruments[0].code;
                _this.siteName=siteData.Site.name;
                let localParames=optionDataInfo[0].data;
                if(localParames){
                    _this.paramsColumns=[];
                    for(let i=0;i<localParames.length;i++){
                        let name=localParames[i].name;
                        if(userInfo.powerFunc == "2"){
                            if(name === "消光系数" || name === "PM2.5" || name === "PM10" || name === "PBL"){
                                _this.paramsColumns.push(name);
                            }
                        }else{
                            _this.paramsColumns.push(name);
                        }
                    }
                }
                _this.startCurrentDate=new Date(_this.getTime(7)); 
                _this.endCurrentDate=new Date(_this.getTime(0)); 
                _this.minDate=new Date(_this.getTime(183));
                _this.startValue=_this.getTime2(7);
                _this.endValue=_this.getTime2(0);
                _this.formData.TimeStart=_this.getTime(7);
                _this.formData.TimeEnd=_this.getTime(0);
            },
            //参数选择
            onPramsChange(value){
                let _this=this;
                _this.showparamsPicker = false;
                let localParames=optionDataInfo[0].data;
                for(let i=0;i<localParames.length;i++){
                    let name=localParames[i].name;
                    if(name === value){
                        console.log(localParames[i]);
                        if(name === "PBL"){
                            _this.showPBL=false;
                        }else{
                            _this.showPBL=true;
                        }
                        _this.PIndex=localParames[i].data.PIndex;
                        _this.paramsVal=value;
                        _this.realTimeParamesName=name;
                        _this.DistanceMax=6000;
                        _this.ChromatogramMax=localParames[i].data.ChromatogramMax;
                        _this.ChromatogramMaxColums=localParames[i].ChromatogramMax;
                    }
                }
                _this.collapseChange();
            },
            //开始时间选择
            onStartChange(value){
                let _this=this;
                let strTime= _this.formatDateToStr(value);
                _this.showStartPicker=false;
                _this.startValue =strTime;
                _this.formData.TimeStart=_this.formatDateToStr2(value);
            },
            //结束时间选择
            onEndChange(value){
                let _this=this;
                let strTime= _this.formatDateToStr(value);
                _this.showEndPicker=false;
                _this.endValue =strTime;
                _this.formData.TimeEnd=_this.formatDateToStr2(value);
            },
            //查询历史数据
            searchData(){
                let _this=this;
                let startTime=new Date(_this.startValue).getTime();
                let endTime=new Date(_this.endValue).getTime();
                // let sevenDay=1000*60*60*24*7;
                // let level=endTime-startTime;
                // if(level > sevenDay){
                //     _this.$toast.fail({
                //         duration:2000,
                //         message:'选择范围应在七天内！'
                //     });
                //     return false
                // }
                if(_this.showPBL === false){
                    _this.PBLSuperposition=false;
                }
                let parameterInfo={
                    "ScanType":1, // 1=垂直 2=水平 3=切面  4=走行       
                    "ProductType":_this.PIndex,
                    "InsType":2,
                    "InsCode":_this.insCode, // 设备Code
                    "DistanceMax":_this.DistanceMax, // 绘制图使用的最大距离
                    "DistanceMin":_this.DistanceMin, //绘制图使用的最小距离
                    "ChromatogramMin":_this.ChromatogramMin, //色谱图下限值
                    "ChromatogramMax":_this.ChromatogramMax, //色谱图上限值
                    "PBLSuperposition":_this.PBLSuperposition, //是否叠加PBL（气溶胶激光雷达会使用）
                    "TimeBegin":_this.formData.TimeStart, //历史查询使用，开始时间
                    "TimeEnd":_this.formData.TimeEnd //历史查询使用，结束时间
                };
                let paramesInfo=JSON.stringify(parameterInfo);
                let url=_this.apiIp.queryRadarHistoryMessage+'?parameter='+paramesInfo;
                let loading=_this.$toast.loading({
                    duration:0,
                    mask: true,
                    message: '加载中...'
                });
                axios.post(url).then(res => {
                    if(res.data.IsSuccess === 1){
                        if(res.data.Data !== "" && res.data.Data !== null){
                            loading.clear();
                            _this.$toast.success({
                                duration:500,
                                mask:true,
                                message:'数据查询完成'
                            });
                            let data = JSON.parse(res.data.Data);
                            let idCode=_this.insCode+"_"+_this.PIndex;
                            let imgUrl=data.Image;
                            if(_this.paramsChartTitle.length > 0){
                                let str=JSON.stringify(_this.paramsChartTitle);
                                if(str.indexOf(idCode) === -1){
                                    let codeObj={code:idCode,url:imgUrl,name:_this.realTimeParamesName};
                                    _this.paramsChartTitle.unshift(codeObj);
                                }else{
                                    for(let i=0;i<_this.paramsChartTitle.length;i++){
                                        let info=_this.paramsChartTitle[i];
                                        let code=info.code;
                                        if(code === idCode){
                                            info.url=imgUrl;
                                        }
                                    }
                                }
                            }else{
                                let codeObj={code:idCode,url:imgUrl,name:_this.realTimeParamesName};
                                _this.paramsChartTitle.push(codeObj);
                            }
                            _this.activeNames=[];
                            _this.collapseChange();
                        }else{
                            loading.clear();
                            _this.$toast.fail({
                                duration:500,
                                mask:true,
                                message:'数据查询失败'
                            });
                            _this.activeNames=[];
                            _this.collapseChange();
                        }
                    }else{
                        loading.clear();
                        _this.$toast.fail({
                            duration:500,
                            mask:true,
                            message:'数据查询失败'
                        });
                        _this.activeNames=[];
                        _this.collapseChange();
                    }
                });            
            },
            //参数选择
            toggle(index) {
                this.$refs.checkboxes[index].toggle();
            },
            //form表单显示隐藏
            collapseChange(){
                let _this=this;
                setTimeout(()=>{
                    _this.setContentHeight();
                },300);
            },
            //设置主体位置高度
            setContentHeight(){
                let tabbarHeight=$(".van-collapse-item").height();
                let homeHeight=$(".history").height();
                $(".historyChart").height(homeHeight-tabbarHeight);
                $(".historyChart").css("top",tabbarHeight);
            },
            //删除图片
            deleteImg(item,index){
                console.log(item);
                let _this=this;
                _this.paramsChartTitle.splice(index,1);
            },
            //时间格式化
            formatDateToStr: function(data) {
                let date = new Date(data);
                // let seperator1 = "-";
                // let seperator2 = ":";
                let month = date.getMonth() + 1<10? "0"+(date.getMonth() + 1):date.getMonth() + 1;
                let strDate = date.getDate()<10? "0" + date.getDate():date.getDate();
                let hour = date.getHours()<10? "0" + date.getHours():date.getHours();
                // let minutes = date.getMinutes()<10? "0" + date.getMinutes():date.getMinutes();
                // let seconds = date.getSeconds()<10? "0" + date.getSeconds():date.getSeconds();
                let currentdate = date.getFullYear() + "年"  + month  + "月"  + strDate + "日"  + hour  + "时";
                return currentdate;
            },
            //时间格式化
            formatDateToStr2: function(data) {
                let date = new Date(data);
                let seperator1 = "-";
                let seperator2 = ":";
                let month = date.getMonth() + 1<10? "0"+(date.getMonth() + 1):date.getMonth() + 1;
                let strDate = date.getDate()<10? "0" + date.getDate():date.getDate();
                let hour = date.getHours()<10? "0" + date.getHours():date.getHours();
                let minutes = date.getMinutes()<10? "0" + date.getMinutes():date.getMinutes();
                let seconds = date.getSeconds()<10? "0" + date.getSeconds():date.getSeconds();
                let currentdate = date.getFullYear() + seperator1  + month  + seperator1  + strDate
                    + " "  + hour  + seperator2  + minutes
                    + seperator2 + seconds;
                return currentdate;
            },
            //获取时间
            getTime(num){
                let date = new Date();
                date.setTime(date.getTime() - 24 * 60 * 60 * 1000 * num);
                let seperator1 = "-";
                let seperator2 = ":";
                let month = date.getMonth() + 1<10? "0"+(date.getMonth() + 1):date.getMonth() + 1;
                let strDate = date.getDate()<10? "0" + date.getDate():date.getDate();
                let hour = date.getHours()<10? "0" + date.getHours():date.getHours();
                let minutes = date.getMinutes()<10? "0" + date.getMinutes():date.getMinutes();
                let seconds = date.getSeconds()<10? "0" + date.getSeconds():date.getSeconds();
                let currentdate = date.getFullYear() + seperator1  + month  + seperator1  + strDate
                    + " "  + hour  + seperator2  + minutes
                    + seperator2 + seconds;
                return currentdate;
            },
            //获取时间
            getTime2(num){
                let date = new Date();
                date.setTime(date.getTime() - 24 * 60 * 60 * 1000 * num);
                // let seperator1 = "-";
                // let seperator2 = ":";
                let month = date.getMonth() + 1<10? "0"+(date.getMonth() + 1):date.getMonth() + 1;
                let strDate = date.getDate()<10? "0" + date.getDate():date.getDate();
                let hour = date.getHours()<10? "0" + date.getHours():date.getHours();
                // let minutes = date.getMinutes()<10? "0" + date.getMinutes():date.getMinutes();
                // let seconds = date.getSeconds()<10? "0" + date.getSeconds():date.getSeconds();
                let currentdate = date.getFullYear() + "年"  + month  + "月"  + strDate + "日"  + hour  + "时";
                return currentdate;
            },
            //改变色谱上限
            onChromatogramMaxChange(value){
                let _this=this;
                _this.showMaxPicker=false;
                _this.ChromatogramMax=value;
            },
            onDistanceMaxColumsChange(value){
                let _this=this;
                _this.showDisMaxPicker=false;
                if(value === "" || value === null || value === "undefined"){
                    _this.DistanceMax=value;
                }else{
                    if(_this.DistanceMin < value){
                        _this.DistanceMax=value;
                    }else{
                        _this.$toast.fail({
                            duration:2000,
                            message:'距离上限必须大于距离下限！'
                        });
                    }
                }
            },
            onDistanceMinColumsChange(value){
                let _this=this;
                _this.showDisMinPicker=false;
                if(value === "" || value === null || value === "undefined"){
                    _this.DistanceMin=value;
                }else{
                    if(_this.DistanceMax > value){
                        _this.DistanceMin=value;
                    }else{
                        _this.$toast.fail({
                            duration:2000,
                            message:'距离上限必须大于距离下限！'
                        });
                    }
                }
            }
        },
        mounted() {
            //this.initChart();
            this.collapseChange();
            this.initSiteData();
            this.onPramsChange("消光系数");
            $(".van-field__body").eq(6).css("border","none");
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    @import "../style/history.css";
    .van-field__body{
        border: 1px solid #ccc4c4;
        padding: 0 0 0 10px;
    }
    .van-cell{
        padding: 3px 15px;
    }
</style>



// WEBPACK FOOTER //
// src/components/History.vue